import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ToasterBySubjectOptions } from './toaster-by-subject.component';

export enum CloseActionTypes {
  UNDO = 'UNDO',
  CLOSE = 'CLOSE',
  VIEW = 'VIEW',
}

export enum ToastBySubjectTypes {
  TELE_MISSED_QUESTION = 'TeleMissedQuestion',
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toastSubject = new Subject<{
    title: string;
    options?: ToasterBySubjectOptions;
  }>();
  isOpen = new Subject<boolean>();

  closeAction: Subject<CloseActionTypes>;

  showCustomToast(options: { title: string; options?: ToasterBySubjectOptions }): Observable<CloseActionTypes> {
    this.toastSubject.next(options);
    if (this.closeAction) {
      // prevent current subscribers to receive next events
      this.closeAction.complete();
    }
    this.closeAction = new Subject<CloseActionTypes>();
    return this.closeAction.asObservable();
  }

  showToast(title: string): Observable<CloseActionTypes> {
    return this.showCustomToast({ title, options: { duration: 10000, hasClose: true } });
  }
}
